import request from '@/utils/request'

/**
 * 社保视频相关 API
 */

// 获取社保视频信息
export function getSocialSecurityVideo(consultantId) {
  return request({
    url: '/consultConsultant/getSocialSecurity',
    method: 'get',
    params: {
      consultantId
    }
  })
}

// 获取云点播上传签名
export function getCloudVodSignature(consultantId) {
  return request({
    url: `/consultConsultant/signature/${consultantId}`,
    method: 'get'
  })
}

// 删除社保视频
export function deleteSocialSecurityVideo(consultantId) {
  return request({
    url: '/consultConsultant/deleteSocialSecurity',
    method: 'delete',
    params: {
      consultantId
    }
  })
}

// 检查用户预约权限
export function checkAppointmentPermission(consultantId) {
  return request({
    url: '/consultConsultant/checkPermission',
    method: 'get',
    params: {
      consultantId
    }
  })
}

// 获取社保示例视频配置信息（已废弃，使用 getDefaultSocialSecurity）
export function getSocialSecurityExampleVideo() {
  return request({
    url: '/consultConsultant/getSocialSecurityExampleVideo',
    method: 'get'
  })
}

// 获取默认社保记录示例视频配置信息
export function getDefaultSocialSecurity() {
  return request({
    url: '/consultConsultant/getDefaultSocialSecurity',
    method: 'get'
  })
}
